var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors;
  return {
    colorGreen: colors.shamrock,
    colorBlue: colors.brand,
    colorRed: colors.crimson,
    colorGrey: colors.ash,
    colorHeaderBottomBorder: colors.tiara,
    cellPadding: '13.5px 13.5px;'
  };
};
export default generateComponentTheme;